<template>
  <Dialog :open="modelValue" @update:open="$emit('update:modelValue', false)">
    <DialogContent class="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle class="text-lg font-medium">Revoke Warning</DialogTitle>
        <DialogDescription class="text-sm text-gray-600">
          Please provide a reason for revoking this warning. This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <div class="grid gap-4">
        <div class="grid gap-2">
          <Label class="text-sm font-medium" for="revocation_reason">
            Reason for revoking warning
            <span class="text-xs text-red-500">*</span>
          </Label>
          <Textarea
            id="revocation_reason"
            v-model="form.reason"
            placeholder="Explain why this warning is being revoked"
            class="bg-white resize-none h-32"
          />
        </div>
      </div>
      <DialogFooter class="flex justify-end gap-2">
        <button
          class="text-xs border-[1px] border-gray-200 rounded-md px-4 py-2 text-gray-500 hover:bg-gray-100 transition-colors"
          @click="$emit('update:modelValue', false)"
        >
          Cancel
        </button>
        <button
          class="text-xs border-[1px] border-red-500 bg-red-500 text-white rounded-md px-4 py-2 hover:bg-red-400 transition-all w-fit flex items-center gap-2"
          :class="{ 'opacity-70': !form.reason || isSubmitting }"
          :disabled="!form.reason || isSubmitting"
          @click="handleSubmit"
        >
          <Loader2 v-if="isSubmitting" class="h-4 w-4 animate-spin" />
          Revoke Warning
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'
import { Loader2 } from 'lucide-vue-next'

const props = defineProps<{
  modelValue: boolean
  isSubmitting: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'submit', data: { reason: string }): void
}>()

const form = ref({
  reason: ''
})

const handleSubmit = () => {
  if (!form.value.reason) return
  emit('submit', { reason: form.value.reason })
  form.value = { reason: '' }
}
</script> 